import { createContext } from "react";
import type { Dispatch, SetStateAction } from "react";

/** Valor del contexto de catálogos/datos transversales (compañías, sucursales, sedes, ubigeo, rutas). */
export interface DataContextValue {
  listaCompanias: any[];
  setListaCompanias: Dispatch<SetStateAction<any[]>>;
  listaSucursales: any[];
  setListaSucursales: Dispatch<SetStateAction<any[]>>;
  listaSedesPorUsuario: any[];
  setListaSedesPorUsuario: Dispatch<SetStateAction<any[]>>;
  listaTipoDocumento: any[];
  setListaTipoDocumento: Dispatch<SetStateAction<any[]>>;
  listaUbigeo: any[];
  setListaUbigeo: Dispatch<SetStateAction<any[]>>;
  listaRutasDeAcceso: any[];
  /** Estado de la carga de RutaPlana (ítem 7): gobierna el guard de navegación en memoria. */
  rutasEstado: "cargando" | "cargado" | "sesion-vencida";
  getDataSelector: () => Promise<void>;
  getCompaniasYSedesPorUsuario: (token: string) => Promise<any>;
  getRutasDeAcceso: (token: string, parametro: string) => Promise<void>;
}

export const DataContext = createContext<DataContextValue | undefined>(undefined);
